import { WorkerAttr } from '@/types/worker-attr';

export function getTagPath(attr: WorkerAttr): string {
  return `${attr.tag}.${attr.id}`;
}
